import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Corporate from "./Corporate";
import AccountHolders from "./AccountHolders";
// import AccountDetails from "./AccountDetails";
import GBPComponent from "./GBPComponent";
import AccountHealth from "./AccountHealth";
import OverDueNextDue from "./OverDueNextDue";
// import InstructionSetCard from "./InstructionSet";
// import RecentTransactions from "./RecentTransactions";
import QuickActionsCard from "./QuickActions";
import { useDispatch, useSelector } from "react-redux";
import useLoanDetails from "./useLoanDetails";
import "./CSSStylesheet.css";
import { LiHandleButton, SpinnerBlock } from "../../../Utils/CustomComponent";
import AchPopup, {
  AchAlertModal,
  AchSetupModal,
  TaxFormModal,
  TaxInfoModal,
} from "./AchPopup";
import useAchData from "../BankAccountACHPayments/useAchData";
// import LoanDetails from "../Pages/LoanDetailsBorrower/LoanDetailsBorrower";
import LoanDetailsComp from "../../LoanDetails";
import { loadingTypes } from "../../../Utils/constant";
import { fetchBorrowerOtherDetails } from "../../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../../hooks/useAbortController";

function LDPBorrower() {
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [showTaxInfo, setShowTaxInfo] = useState(false);
  const [showAchForm, setShowAchForm] = useState(false);
  const [showAchAlert, setShowAchAlert] = useState(() =>
    sessionStorage.getItem("achAlert")
      ? JSON.parse(sessionStorage.getItem("achAlert"))
      : false
  );
  const [achCondition, setAchCondition] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [refresh, setRefresh] = useState(false);

  const loanId = useSelector((state) => state.account.lenderId);
  const { data, status } = useLoanDetails(loanId);
  const { fetchACHData, achData, loading } = useAchData();
  const { signal } = useAbortController();
  const otherDetails = useSelector(
    (state) => state.dashboard.borrowerOtherDetails.data
  );
  // const otherStatus = useSelector(
  //   (state) => state.dashboard.borrowerOtherDetails.status
  // );
  const dispatch = useDispatch();

  const achAlert = JSON.parse(sessionStorage.getItem("achAlert"));

  useEffect(() => {
    if (loanId) {
      fetchACHData(loanId);
      dispatch(fetchBorrowerOtherDetails({ loanID: loanId, signal }));
    }
  }, [loanId, signal, dispatch]);

  useEffect(() => {
    if (loanId && refresh) {
      fetchACHData(loanId);
      dispatch(fetchBorrowerOtherDetails({ loanID: loanId, signal }));
    }
  }, [refresh, loanId, signal, dispatch]);

  useEffect(() => {
    if (achData?.length) {
      const show = achData[0].DISABLE_YN.toLowerCase() === "y" ? true : false;
      const achCase =
        achData[0].DISABLE_ACH.toLowerCase() === "y" ? true : false;

      if (!show && achCase) {
        setShowAchAlert(true);
      }
      setShowTaxForm(show);
      setAchCondition(achCase);
    }
  }, [achData?.length]);

  return (
    <div>
      {!loading ? (
        <Container fluid style={{ marginBottom: "1.5rem" }}>
          <div>
            <ul className="nav nav-tabs my-5">
              {tabButtons.map((data, index) => (
                <LiHandleButton
                  key={index}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  label={data.label}
                  value={index}
                  handleBtnClick={setActiveTab}
                />
              ))}
            </ul>
          </div>
          {activeTab === 0 ? (
            status === loadingTypes.fulfilled ? (
              <Row className="g-2 bg-white p-3 rounded">
                <Row className=" mb-1 gx-0">
                  <Col sm={12} md={12} lg={3} className="d-flex flex-column">
                    <Corporate account_details={data?.account_details} />
                  </Col>
                  <Col className="ms-2 mb-4">
                    <GBPComponent kpi={data?.kpi} />
                  </Col>
                </Row>

                <Row className=" mb-1 gx-0">
                  <Col xs={12} sm={6} md={6} lg={4}>
                    <AccountHolders Account_Holder={data?.account_holder} />
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={4}>
                    <div className="card-container d-flex flex-column h-100">
                      <AccountHealth
                        InsuranceDetails={data?.insurance_details}
                        style={{ marginLeft: "5px" }}
                      />

                      <QuickActionsCard
                        accountType={data?.account_details?.[0]?.status}
                      />
                    </div>
                  </Col>

                  <Col xs={12} sm={12} md={12} lg={4}>
                    <OverDueNextDue overdueNextDue={otherDetails} />
                  </Col>
                </Row>
                <Col sm={12} lg={9}>
                  {/* <Row>
                  <Col className="ms-2 mb-4">
                    <GBPComponent kpi={data?.kpi} />
                  </Col>
                </Row> */}
                  <Row>
                    {/* {data?.kpi?.[0] ? (
                      <Col xs={12} sm={6} md={6}>
                        {" "}
                        <div className="card-container d-flex flex-column h-100">
                          <AccountHealth
                            InsuranceDetails={data?.insurance_details}
                            style={{ marginLeft: "5px" }}
                          />

                          <QuickActionsCard />
                        </div>
                      </Col>
                    ) : (
                      <Col xs={12} sm={6} md={6}>
                        <div>
                          <SpinnerBlock />
                        </div>
                      </Col>
                    )} */}
                    {/* <Col xs={12} sm={6} md={6}>
                      <div className="card-container">
                        <OverDueNextDue
                          overdueNextDue={data?.overdue_nextdue}
                        />
                      </div>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            ) : (
              <div className="" style={{ height: "60vh" }}>
                <SpinnerBlock height="10vh" />
              </div>
            )
          ) : null}
          {activeTab === 1 ? (
            <LoanDetailsComp isABorrower={true} borrowerLoanId={loanId} />
          ) : null}
          <TaxFormModal
            show={showTaxForm}
            setShow={setShowTaxForm}
            setShowTaxInfo={setShowTaxInfo}
          />

          <TaxInfoModal
            show={showTaxInfo}
            setShow={setShowTaxInfo}
            setShowAchAlert={setShowAchAlert}
            achCondition={achCondition}
            setRefresh={setRefresh}
          />
          <AchAlertModal
            show={showAchAlert}
            setShow={setShowAchAlert}
            setShowAchSetup={setShowAchForm}
          />
          <AchSetupModal
            show={showAchForm}
            setShow={setShowAchForm}
            setRefresh={setRefresh}
          />
        </Container>
      ) : (
        <div>
          <SpinnerBlock height="50vh" />
        </div>
      )}
    </div>
  );
}

export default LDPBorrower;

const tabButtons = [
  { label: <p>Loan Summary</p>, title: "Loan Summary", key: 0 },
  { label: <p>Loan Details</p>, title: "Loan Details", key: 1 },
];
